import { ClientProxy } from '../../../../../base/proxy/clientProxy'
import { IRequesterInfo } from '../../../../../base/models'

export class CreateReceiptFromSuccessApi extends ClientProxy {
  constructor(requesterInfo: IRequesterInfo) {
    super({
      url: 'admin/sapRecord/createReceiptFromSuccess',
      requesterInfo,
    })
  }

  public async createReceipt(req: any): Promise<any> {
    return await this.postAsync<any>(req)
  }
}
